/// shim for browser packaging

module.exports = function() {
  return global.WebSocket || global.MozWebSocket;
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/ws/lib/browser.js
 ** module id = 46
 ** module chunks = 0
 **/